import { useEffect, useState } from "react";

export const SmartImg = ({ src, fallback, alt, className = "" }) => {
    const [current, setCurrent] = useState(src);
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        setCurrent(src);
        setFailed(false);
    }, [src]);

    if (failed) {
        return (
            <div className={`flex items-center justify-center bg-[#e8e6e1] ${className}`}>
                <span className="font-mono text-xs text-neutral-500 tracking-widest uppercase">
                    [ image unreadable ]
                </span>
            </div>
        );
    }
    return (
        <img
            src={current}
            alt={alt}
            loading="lazy"
            draggable={false}
            className={className}
            onError={() => {
                if (fallback && current !== fallback) setCurrent(fallback);
                else setFailed(true);
            }}
        />
    );
};

export const Tag = ({ children }) => (
    <span className="font-mono text-[11px] px-2 py-0.5 rounded border border-black/20 bg-black/[0.04] text-neutral-600">
        {children}
    </span>
);
